import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css"

const Navdata = () => {
    const history = useNavigate();

    const [isDashboard, setIsDashboard] = useState(false);    
    const [isLogout, setIsLogout] = useState(false);
    const [isLock, setIsLock] = useState(false);
    const [iscurrentState, setIscurrentState] = useState('Dashboard');    
    const [isNotifications, setIsNotifications] = useState(false);
    const [isHelp, setIsHelp] = useState(false);
    const [isVehicules, setIsVehicules] = useState(false);
    const [isDrivers, setIsDrivers] = useState(false);
    const [isInspections, setIsInspections] = useState(false);
    const [isAdministration, setIsAdministration] = useState(false);
    const [isUsers, setIsUsers] = useState(false);
    const [isRoles, setIsRoles] = useState(false);
    const [isCatalog, setIsCatalog] = useState(false);
    const [isIncidents, setIsIncidents] = useState(false);
    const [isMateriels, setIsMateriels] = useState(false);
    const [isDemandes, setIsDemandes] = useState(false);
    const [isStocke, setIsStocke] = useState(false);

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }
    
    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Vehicules') {
            setIsVehicules(false);
        }
        if (iscurrentState !== 'Drivers') {
            setIsDrivers(false);
        }
        if (iscurrentState !== 'Inspections') {
            setIsInspections(false);
        }
        if (iscurrentState !== 'Incidents') {
            setIsIncidents(false);
        }
        if (iscurrentState !== 'Notifications') {
            setIsNotifications(false);
        }
        if (iscurrentState !== 'Help') {
            setIsHelp(false);
        }
        if (iscurrentState !== 'Administrations') {
            setIsAdministration(false);
        }
        if (iscurrentState !== 'Users') {
            setIsUsers(false);
        }
        if (iscurrentState !== 'Roles') {
            setIsRoles(false);
        }
        if (iscurrentState !== 'Catalogues') {
            setIsCatalog(false);
        }
        if (iscurrentState !== 'Verouiller') {
            setIsLock(false);
        }
        if (iscurrentState !== 'Materiels') {
            setIsMateriels(false);
        }
        if (iscurrentState !== 'Demandes') {
            setIsDemandes(false);
        }
        if (iscurrentState !== 'Stocke') {
            setIsStocke(false);
        }
        if (iscurrentState !== 'Deconnexion') {
            setIsLogout(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isVehicules,
        isDrivers,
        isLock,
        isLogout,
        isNotifications,
        isHelp,
        isInspections,
        isIncidents,
        isAdministration,
        isUsers,
        isRoles,
        isCatalog,
        isMateriels,
        isDemandes,
        isStocke
    ]);

    const menuItems = [
        {
            label: "Menu",
            isHeader: true,
            isSA: false,
        },
        {
            id: "dashboard",
            label: "Tableau de Bord",
            icon: "las la-tachometer-alt",
            link: "/dashboard",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Dashboard');
            }
        },
        {
            id: "vehicule",
            label: "Vehicules",
            icon: "las la-car-side",
            link: "/vehicles",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Vehicules');
            }
        },
        {
            id: "drivers",
            label: "Chauffeurs",
            icon: "las la-radiation-alt",
            link: "/drivers",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Drivers');
            }
        },
        {
            id: "inspections",
            label: "Inspections",
            icon: "las la-clipboard-check",
            link: "/inspections",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Inspections');
            }
        },
        {
            id: "incidents",
            label: "Incidents",
            icon: "las la-exclamation-triangle",
            link: "/incidents",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Incidents');
            }
        },
        {
            id: "materiels",
            label: "Materiels",
            icon: "las la-tools",
            link: "#",
            isSA: false,
            stateVariables: isMateriels,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Demandes');
                setIsMateriels(!isMateriels);
                setIscurrentState('Materiels');
                updateIconSidebar(e)
            },
            subItems: [
                {
                    id: "demandes",
                    label: "Demandes",
                    link: "/demandes-materiels",
                    parentId: "materiels",
                },
                {
                    id: "stocke",
                    label: "Stocke",
                    link: "/stocke",
                    parentId: "materiels",
                }
            ]
        },
        {
            label: "Paramètres",
            isHeader: true,
            isSA: false,
        },
        {
            id: "catalogs",
            label: "Statut",
            icon: "las la-check-circle",
            link: "/statut",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Catalogues');
            }
        },
        {
            id: "administration",
            label: "Administration",
            icon: "las la-user-plus",
            link: "#",
            isSA: false,
            stateVariables: isAdministration,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Users');
                setIsAdministration(!isAdministration);
                setIscurrentState('Administrations');
                updateIconSidebar(e)
            },
            subItems: [
                {
                    id: "users",
                    label: "Utilisateurs",
                    link: "/utilisateurs",
                    parentId: "administration",
                },
                {
                    id: "roles",
                    label: "Roles",
                    link: "/roles",
                    parentId: "administration",
                }
            ]
        },
        {
            id: "notifications",
            label: "Notification",
            icon: "ri-notification-3-line",
            link: "/notifications",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Notifications');
            },
        },
        {
            id: "help",
            label: "Aide",
            icon: "las la-question",
            link: "/help",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Help');
            },
        },
        {
            label: "Connectivité",
            isHeader: true,
            isSA: false,
        }, 
        {
            id: "lock",
            label: "Verouiller",
            icon: "ri ri-lock-2-line",
            link: "/lock",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Verouiller');
            },
        },
        {
            id: "logout",
            label: "Déconnexion",
            icon: "las la-sign-out-alt",
            link: "/logout",
            isSA: false,
            click: function (e) {
                e.preventDefault();
                setIscurrentState('Deconnexion');
            },
        },
    ];
    return (
        <React.Fragment>
            {menuItems}
        </React.Fragment>
    );
};
export default Navdata;